import { render, staticRenderFns } from "./DialerSwitch.vue?vue&type=template&id=4bd955be&scoped=true&"
import script from "./DialerSwitch.vue?vue&type=script&lang=js&"
export * from "./DialerSwitch.vue?vue&type=script&lang=js&"
import style0 from "./DialerSwitch.vue?vue&type=style&index=0&id=4bd955be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd955be",
  null
  
)

export default component.exports